export default __webpack_public_path__ + "6cd1169de4f552f6dba5dfa7b5e1ad0e.png";